import { Organization, Role } from 'interfaces';
import { adminSchema } from '@billing/validation/admin';

export interface Admin {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  status: string;
  cognitoID: string;
  role?: Role;
  organization?: Organization;
  roleID?: string;
  organizationID?: string;
  providerID?: string;
}

export type FormAdmin = Omit<Admin, 'id'>;

export const isAdmin = (obj: any): obj is Admin => {
  return adminSchema.safeParse(obj).success;
};
